import RelatorioEmDesenvolvimento from "../../../components/RelatorioEmDesenvolvimento";

const MapaAplicInsumos = () => (
  <RelatorioEmDesenvolvimento
    titulo="Mapa de Aplicação de Insumos"
    descricao="Vai depender de georreferenciamento de talhões, que ainda não existe no sistema."
  />
);

export default MapaAplicInsumos;
